module.exports = __webpack_public_path__ + "static/media/panoramicWindow.abb8234d.png";